import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import 'leaflet/dist/leaflet.css';
// import 'moment/locale/en-gb';
// import moment from 'moment';

// moment.locale('en-gb');

const tagManagerArgs = {
  gtmId: 'GTM-PHH2KT'
};

// ─── Suppress CRA dev overlay for cross-origin "Script error." ───────────────
// CRA 5.x installs a window.addEventListener('error', handleError) to power its
// dev overlay. Cross-origin scripts (GTM, Stripe) emit "Script error." with no
// origin info — these are meaningless noise. We patch addEventListener BEFORE
// CRA/GTM run so their handler never sees these opaque events.
if (process.env.NODE_ENV === 'development') {
  const _origAddEventListener = window.addEventListener.bind(window);
  window.addEventListener = function (type, listener, options) {
    if (type === 'error' && typeof listener === 'function') {
      const wrapped = function (event) {
        // Skip cross-origin "Script error." with no useful info
        if (
          event.message === 'Script error.' &&
          !event.filename &&
          event.lineno === 0 &&
          event.colno === 0 &&
          !event.error
        ) {
          return;
        }
        return listener.call(this, event);
      };
      return _origAddEventListener(type, wrapped, options);
    }
    return _origAddEventListener(type, listener, options);
  };

  // Also cover the legacy window.onerror path
  const _origOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (message === 'Script error.' && !source && !lineno && !colno && !error) {
      return true;
    }
    if (_origOnError) return _origOnError(message, source, lineno, colno, error);
    return false;
  };
}

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
